"use client";
import React from "react";
import apiFetcher from "provider/magento/apiFetcher";
import {getRelatedProducts} from "provider/magento/api/products";
import ProductSlider from "app/components/ProductSlider/ProductSlider";
import {normalizePaginatedProducts} from "provider/magento/normalizers";
import { usePhrase} from "../../i18n";
import ProductCard from "../ProductCard/ProductCard";
import useSWRImmutable from "swr/immutable";


export default function RelatedProducts({product,store, storeCode, _t}) {

    const t = usePhrase(_t);
    //const t = await getTranslator(storeCode);

    //const paginatedProducts = await apiFetcher(...getRelatedProducts(product.id, storeCode)).then(data => normalizePaginatedProducts(data));

    const {data: paginatedProducts} = useSWRImmutable(getRelatedProducts(product.id, storeCode), ([endpoint,options])=>apiFetcher(endpoint,options).then(res => normalizePaginatedProducts(res)));

    return (<div className={'lg:container px-2 mx-auto my-8 min-h-[400px]'}>
            <hr className={`spacer my-3`} />
            <div className="related-products">
                    <div>
                        <h3 className={'font-bold text-2xl py-3'}>{t('Often bought together')}</h3>
                    </div>
                    {paginatedProducts && paginatedProducts.items && <div className={'product-slider-container w-full'}>
                        <ProductSlider paginatedProducts={paginatedProducts}>
                            {paginatedProducts?.items.filter(p => p.visibility === 4).length > 0 && paginatedProducts.items.filter(p => p.visibility === 4).map(p =>
                                <ProductCard key={'product_card_rp_' + p.id} {...p} store={store} storeCode={storeCode} className={'min-w-[90%] lg:min-w-[290px] md:min-w-[80%] lg:w-1/4 '} _t={_t} inSlider={false}/>
                            )}
                        </ProductSlider>
                    </div>}
            </div>
        </div>
    );
}